<tux-page-header
  [subMenu]="true"
  pageTitle="Creative Library"
  description="The Creative Library showcases all the creative content attached to your DemandScience Ad campaigns. Browse and manage creatives for your Display, Audio, Video, and CTV advertising here."
  [breadcrumbs]="[
        {
          path: '',
          title: 'Home',
        },
        {
          title: 'Creative Library',
        },
  ]"
>
  <tux-page-header-buttons>
    <p-button
      data-testid="uploader-button"
      (click)="showUploader = true; creativesUploaded = false"
    >
      <fa-icon [icon]="faUpload"></fa-icon>
      Upload
    </p-button>
  </tux-page-header-buttons>
</tux-page-header>

<div>
  <lf-mini-filter-row
    miniFilters
    [filterManager]="filterManager"
    class="flex gap-3"
    id="mini-filters"
  >
  </lf-mini-filter-row>

  <lf-protocols-prime-table
    reportName="assets"
    protocolName="details_table"
    [rowActions]="rowActions"
    [reportFilterManager]="filterManager"
    [dataContext]="dataContext | async"
    [searchFilter]="tableFilter"
    [selectionAllowed]="false"
    [downloadEnabled]="false"
    (selectedItemsChange)="this.selectedAssets.emit($event.rows || [])"
    [allowIndefinateSelection]="false"
    [backupRowIDs]="['asset']"
    [scrollable]="true"
  >
  </lf-protocols-prime-table>
</div>

<lf-global-vertical-filter-rail
  [filterManager]="filterManager"
></lf-global-vertical-filter-rail>

<lib-creative-uploader
  #creativeUploader
  [showUploader]="showUploader"
  [openingTabIndex]="openingTabIndex"
  [creativeUploaded]="creativesUploaded"
  (onClose)="showUploader = false; handleUploadModalClose()"
  (audioBannerUploaded)="refreshInterval.next(1000)"
  (creativeUploadedChanged)="creativesUploaded = true"
></lib-creative-uploader>

<input
  #audioBannerFileInput
  type="file"
  style="display: none"
  (change)="
    creativeUploader.selectAudioBannerFile($event, selectedAudioAssetId)
  "
/>

<p-toast
  key="library-toast"
  position="top-center"
  [preventOpenDuplicates]="true"
>
  <!-- allow for HTML(a hyperlink in this case) in toast message -->
  <ng-template let-message pTemplate="message">
    <p class="text-center" innerHtml="{{ message.detail }}"></p>
  </ng-template>
</p-toast>
